exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main {\n  margin-left: 27rem;\n  padding-top: 8rem; }\n  @media (max-width: 767px) {\n    .main {\n      padding-top: 6rem; } }\n\n.login {\n  margin-left: 0 !important;\n  padding-top: 0 !important;\n  background: url(\"/assets/img/BackgroundSignIn.jpg\") center no-repeat;\n  background-size: cover;\n  width: 100%;\n  position: relative; }\n  .login:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: url(\"/assets/img/finger.png\") center no-repeat;\n    background-size: contain; }\n\n.overlay {\n  position: fixed;\n  display: none;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 8; }\n\n.animate-opacity {\n  -webkit-animation: opac 0.8s;\n          animation: opac 0.8s; }\n\n@media (max-width: 991px) {\n  .main {\n    margin-left: 0; }\n  #overlay {\n    display: block;\n    cursor: pointer; } }\n\n#overlay {\n  display: block;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/core/main/main.component.scss
// module id = ../../../../../src/app/core/main/main.component.scss
// module chunks = 2